// extracted by mini-css-extract-plugin
module.exports = {"suggest-button":"suggests_suggest-button__2P-vm","suggests-wrap":"suggests_suggests-wrap__1N5nl","suggests-list":"suggests_suggests-list__1UcuS"};